import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "utilityVanSmall"
const UtilityVanSmallIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M15.697 7.313C16.387 7.313 17.031 7.657 17.413 8.23L19.121 10.792 20.456 11.327C20.868 11.492 21.17 11.853 21.257 12.287L21.562 13.82V16.125C21.563 16.85 20.976 17.438 20.25 17.438H19.702C19.325 18.424 18.37 19.125 17.25 19.125 16.13 19.125 15.175 18.425 14.798 17.438H8.828C8.45 18.424 7.493 19.125 6.374 19.125 5.255 19.125 4.3 18.425 3.923 17.438H3.375C2.65 17.438 2.063 16.85 2.063 16.125V11.901L2.096 11.808 3.416 8.177C3.607 7.658 4.099 7.313 4.65 7.313zM6.375 15.375C5.754 15.375 5.25 15.879 5.25 16.5S5.754 17.625 6.375 17.625 7.5 17.121 7.5 16.5 6.996 15.375 6.375 15.375M17.25 15.375C16.629 15.375 16.125 15.879 16.125 16.5S16.629 17.625 17.25 17.625 18.375 17.121 18.375 16.5 17.871 15.375 17.25 15.375M4.65 8.438C4.571 8.438 4.501 8.488 4.474 8.56L3.187 12.1V12.562H3.376C3.685 12.563 3.938 12.815 3.938 13.126S3.686 13.688 3.375 13.688H3.188V16.125C3.188 16.229 3.27 16.313 3.375 16.313H3.758C3.854 14.95 4.988 13.875 6.375 13.875S8.895 14.95 8.992 16.313H14.633C14.73 14.95 15.863 13.875 17.25 13.875S19.77 14.95 19.867 16.313H20.25C20.354 16.313 20.438 16.229 20.438 16.125V14.438H20.25C19.94 14.438 19.688 14.186 19.688 13.875S19.939 13.313 20.25 13.313H20.314L20.154 12.509C20.14 12.447 20.097 12.395 20.038 12.371L18.642 11.812H15.442C14.965 11.813 14.525 11.555 14.294 11.138L12.794 8.437zM15.278 10.59C15.31 10.65 15.374 10.688 15.442 10.688H17.699L16.477 8.855C16.303 8.595 16.011 8.438 15.697 8.437H14.081z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default UtilityVanSmallIcon
